import { useSubscribeWebsocket } from "hooks"

export const OddsSubscriber = () => {
  // setup a WebSocket connection for atlas and odds
  useSubscribeWebsocket()

  return null
}
